module.exports = __webpack_public_path__ + "static/bulk-storage-8404f8fdd2a6a331c4dd4e90176492cd.jpg";